/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.216.0-v202610292315-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqAuthApiClass {
 
   constructor() {}

  /**
   * @summary Get a collection of authentication providers
   * @param {Array<string>} [includeAuthProviderIds] - The ID(s) of the authentication provider to include even if it is hidden. For multiple value, use comma delimiter.
   * @param {boolean} [onlyExcludingEveryoneGroup] - If true, return all authentication providers that are excluded from the Everyone group.
  */
  public getAuthProviders(
    {
      includeAuthProviderIds,
      onlyExcludingEveryoneGroup
    } : {
      includeAuthProviderIds?: Array<string>,
      onlyExcludingEveryoneGroup?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/auth/providers`;
    const urlTemplate = `${baseUrl}/auth/providers`;

    const queryParams = {
      ['includeAuthProviderIds']: includeAuthProviderIds,      ['onlyExcludingEveryoneGroup']: onlyExcludingEveryoneGroup
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AuthProvidersOutputV1>;
  }

  /**
   * @summary Get a valid CSRF token for this authentication session
  */
  public getCsrf(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/auth/csrf`;
    const urlTemplate = `${baseUrl}/auth/csrf`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Login
  */
  public login(
    body: models.AuthInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/auth/login`;
    const urlTemplate = `${baseUrl}/auth/login`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.UserOutputV1>;
  }

  /**
   * @summary Invalidate the session to be completely unusable
  */
  public logout(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/auth/logout`;
    const urlTemplate = `${baseUrl}/auth/logout`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Request password reset
  */
  public requestPasswordReset(
    body: models.RequestPasswordResetInput,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/auth/request-password-reset`;
    const urlTemplate = `${baseUrl}/auth/request-password-reset`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Perform password reset
  */
  public resetPassword(
    body: models.PasswordResetInput,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/auth/reset-password`;
    const urlTemplate = `${baseUrl}/auth/reset-password`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

}


export const sqAuthApi = new sqAuthApiClass();

export type sqAuthApiEndpoints = {
  'getAuthProviders': {
    method: 'get';
    path: '/auth/providers';
    response: models.AuthProvidersOutputV1;
  };
  'getCsrf': {
    method: 'get';
    path: '/auth/csrf';
    response: {};
  };
  'login': {
    method: 'post';
    path: '/auth/login';
    response: models.UserOutputV1;
  };
  'logout': {
    method: 'delete';
    path: '/auth/logout';
    response: {};
  };
  'requestPasswordReset': {
    method: 'post';
    path: '/auth/request-password-reset';
    response: {};
  };
  'resetPassword': {
    method: 'post';
    path: '/auth/reset-password';
    response: {};
  };
};

type ApiGetAuthProvidersResponse = models.AuthProvidersOutputV1;
export function GetAuthProvidersQueryKey(
  params: Parameters<typeof sqAuthApi.getAuthProviders>[0],
) {
  return ['sqAuthApi', 'getAuthProviders', params] as const;
}

export function useApiGetAuthProvidersQuery(
  params: Parameters<typeof sqAuthApi.getAuthProviders>[0],
  options?: Omit<UseQueryOptions<ApiGetAuthProvidersResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAuthProvidersResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAuthProvidersQueryKey(params),
    queryFn: () =>
      sqAuthApi.getAuthProviders(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetCsrfResponse = {};
export function GetCsrfQueryKey(
) {
  return ['sqAuthApi', 'getCsrf'] as const;
}

export function useApiGetCsrfQuery(
  options?: Omit<UseQueryOptions<ApiGetCsrfResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetCsrfResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetCsrfQueryKey(),
    queryFn: () =>
      sqAuthApi.getCsrf(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiLoginResponse = models.UserOutputV1;
type ApiloginMutationParams = Parameters<typeof sqAuthApi.login> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAuthApi.login>;
type ApiloginMutationVariables = models.AuthInputV1;

export function useApiLoginMutation(
  options?: Omit<UseMutationOptions<ApiLoginResponse, AxiosError<SeeqErrorData>,
    ApiloginMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiLoginResponse, AxiosError<SeeqErrorData>,
  ApiloginMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiloginMutationVariables) =>
      sqAuthApi.login(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiLogoutResponse = {};
type ApilogoutMutationParams = Parameters<typeof sqAuthApi.logout> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAuthApi.logout>;

export function useApiLogoutMutation(
  options?: Omit<UseMutationOptions<ApiLogoutResponse, AxiosError<SeeqErrorData>,
    ApilogoutMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiLogoutResponse, AxiosError<SeeqErrorData>,
  ApilogoutMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: () => sqAuthApi.logout(resolvedOverrides).then((response) => response.data),
    
    ...mutationOptions,
  });
}
type ApiRequestPasswordResetResponse = {};
type ApirequestPasswordResetMutationParams = Parameters<typeof sqAuthApi.requestPasswordReset> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAuthApi.requestPasswordReset>;
type ApirequestPasswordResetMutationVariables = models.RequestPasswordResetInput;

export function useApiRequestPasswordResetMutation(
  options?: Omit<UseMutationOptions<ApiRequestPasswordResetResponse, AxiosError<SeeqErrorData>,
    ApirequestPasswordResetMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRequestPasswordResetResponse, AxiosError<SeeqErrorData>,
  ApirequestPasswordResetMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApirequestPasswordResetMutationVariables) =>
      sqAuthApi.requestPasswordReset(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiResetPasswordResponse = {};
type ApiresetPasswordMutationParams = Parameters<typeof sqAuthApi.resetPassword> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAuthApi.resetPassword>;
type ApiresetPasswordMutationVariables = models.PasswordResetInput;

export function useApiResetPasswordMutation(
  options?: Omit<UseMutationOptions<ApiResetPasswordResponse, AxiosError<SeeqErrorData>,
    ApiresetPasswordMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiResetPasswordResponse, AxiosError<SeeqErrorData>,
  ApiresetPasswordMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiresetPasswordMutationVariables) =>
      sqAuthApi.resetPassword(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
